export const VEHICLE_VARIANT = {
  LUCID_AIR_PURE: 'Air Pure',
  LUCID_AIR_TOURING: 'Air Touring',
  LUCID_AIR_GRAND_TOURING: 'Air Grand Touring',
  LUCID_AIR_DREAM_EDITION: 'Air Dream Edition (Limited)',
  LUCID_GRAVITY: 'Gravity (Coming soon)',
};
